import settings from '../../../config/settings';

export default {
  'app.global.route.auth.login': 'Login',
  'app.global.form.validatefields.catch':
    'The validation did not pass, please check the input',
  'app.global.request.catch': 'Request Fail',
  'app.global.request.catch.description': 'Fail request {status}: { text }',
  'app.global.no.response.description':
    'An error occurred during connection, cannot connect to the server',
  'app.global.no.response.message': 'Connection failed !',
  'app.global.login.expired':
    'Your current login session has expired. Please log in again to continue.',
  'app.global.error': 'Error',
  'app.global.something.wrong': 'Something wrong...',
  'app.global.custom.error.message': 'An unknown error occurred ',
  'app.global.not.found': 'Not found',
  'app.global.yes': 'Yes',
  'app.global.no': 'No',
  'app.global.not.access': 'Not access',
  'app.global.success': 'Success',
  'app.global.success.delete': 'Deleted successfully!',
  'app.global.success.create': 'Created successfully!',
  'app.global.success.update': 'Updated successfully!',
  'app.global.attachFile': 'Attach file',
  'app.global.siteName': settings.siteName,
  'app.global.confirm': 'Confirm',
  'app.global.cancel.change':
    'All changes have not been saved. Do you want to cancel ?',
  'app.global.custom.error.permission.access.page': `You don't have permission to access this page!`,

  // Table field translations
  'app.global.add.row': 'Add Row',
  'app.global.add.column': 'Add Column',
  'app.global.column': 'Column',
  'app.global.title': 'Title',
  'app.global.type': 'Type',
  'app.global.options': 'Options',
  'app.global.options.placeholder': 'Enter options and press Enter',
  'app.global.table.columns': 'Table Columns',
  'app.global.action': 'Action',
  'app.global.required': 'Required',
  'app.global.field.required': 'This field is required',

  'app.global.error.delete': 'Delete failed!',
  'app.global.error.update': 'Update failed!',
  'app.global.error.create': 'Create failed!',

  'input.placeholder.type': 'Type here...',
  'input.enter': 'Enter',
  'input.select': 'Select',
  'input.placeholder.choose.one': 'Choose one',
  'input.placeholder.date': 'Select date',
  'input.required': '{fieldName} is required',
  'input.label.checkAll': 'Check all',

  'table.title.actions': 'Actions',

  'app.global.custom.field': 'Field',
  'app.global.custom.label': 'Label',
  'app.global.custom.type': 'Type',
  'app.global.custom.key': 'Key (auto-filled)',
  'app.global.custom.required': 'Required',
  'app.global.custom.options': 'Options',
  'app.global.custom.options.placeholder': 'Enter options for field',
  'app.global.custom.switch.on': 'On',
  'app.global.custom.switch.off': 'Off',
  'app.global.column.move.up': 'Move Up',
  'app.global.column.move.down': 'Move Down',
  'app.global.column.remove': 'Remove Column',
  'app.global.custom.dataSource.config': 'Data Source Configuration',
  'app.global.custom.dataSource.type': 'Data Source Type',
  'app.global.custom.dataSource.static': 'Static Options',
  'app.global.custom.dataSource.model': 'Predefined Model',
  'app.global.custom.dataSource.api': 'API',
  'app.global.custom.dataSource.model.select': 'Select Model',
  'app.global.custom.dataSource.model.placeholder': 'Select a model',
  'app.global.custom.dataSource.api.url': 'API URL',
  'app.global.custom.dataSource.api.url.placeholder': 'Enter API URL',
  'app.global.custom.dataSource.api.responsePath': 'Response Data Path',
  'app.global.custom.dataSource.api.responsePath.placeholder':
    'e.g., data.items',
  'app.global.custom.dataSource.api.responsePath.help':
    'Path to the array of items in the API response (e.g., data, data.items, results)',
  'app.global.custom.dataSource.mapping': 'Field Mapping',
  'app.global.custom.dataSource.labelField': 'Label Field',
  'app.global.custom.dataSource.labelField.placeholder': 'e.g., name, title',
  'app.global.custom.dataSource.valueField': 'Value Field',
  'app.global.custom.dataSource.valueField.placeholder': 'e.g., id, code',
  'app.global.custom.dataSource': 'Data Source',
  'app.global.custom.dataSource.cache': 'Cache',
  'app.global.custom.dataSource.cache.enabled': 'Cache Enabled',
  'app.global.custom.dataSource.cache.expiration': 'Cache Expiration (minutes)',
  'app.global.custom.dataSource.predefined': 'Predefined Data Source',
  'app.global.custom.dataSource.dynamic': 'Dynamic Data Source',
  'app.global.custom.dataSource.loading': 'Loading data source...',
  'app.global.custom.dataSource.error': 'Error loading data source',
  'app.global.custom.dataSource.empty': 'No data available',
  'app.global.custom.dataSource.select': 'Select Data Source',
  'app.global.custom.dataSource.refresh': 'Refresh Data Source',
  'app.global.custom.dataSource.clear.cache': 'Clear Cache',
};
